$(document).on('turbo:load turbo:render', function(){
  $('.datetime-picker').datetimepicker({
    // timeFormat: 'hh:mm tt z'
    dateFormat: 'dd-mm-yy',
    timeFormat: 'hh:mm tt'
  });
});
